import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "../style";
import { Dialog } from "component/shared/dialog";

interface Props extends
	WithStyles<typeof styles>
{
	deleteLeadDialogIsOpen: boolean;
	hideDeleteLeadDialog: Function;
	deleteLead: Function;

}

const component = (props: Props) => {
	
	const { deleteLeadDialogIsOpen, hideDeleteLeadDialog, deleteLead, classes = {} } = props;
	
	return (

		<Dialog
			open={deleteLeadDialogIsOpen}
			onClose={() => hideDeleteLeadDialog()}
		>
			<Mui.DialogTitle>Delete Contact</Mui.DialogTitle>
			<Mui.DialogContent className={classes.dialogContent}>
				<Mui.DialogContentText>
					Are you sure you want to delete this contact?
				</Mui.DialogContentText>
			</Mui.DialogContent>
			<Mui.DialogActions className={classes.dialogActions}>
				<Mui.Button onClick={() => hideDeleteLeadDialog()} variant="outlined" color="primary">
					No
				</Mui.Button>
				<Mui.Button
					onClick={() => deleteLead()}
					variant="contained"
					color="primary"
				>
					Yes
				</Mui.Button>
			</Mui.DialogActions>
		</Dialog>
	);
};

export const DeleteLeadDialog = withStyles(component, styles);